/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordSetAttestationData } from './PasswordSetAttestationData';
import {
    PasswordSetAttestationDataFromJSON,
    PasswordSetAttestationDataFromJSONTyped,
    PasswordSetAttestationDataToJSON,
    PasswordSetAttestationDataToJSONTyped,
} from './PasswordSetAttestationData';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordSetAttestation
 */
export interface PasswordSetAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordSetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordSetAttestationData}
     * @memberof PasswordSetAttestation
     */
    data?: PasswordSetAttestationData;
}



/**
 * Check if a given object implements the PasswordSetAttestation interface.
 */
export function instanceOfPasswordSetAttestation(value: object): value is PasswordSetAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function PasswordSetAttestationFromJSON(json: any): PasswordSetAttestation {
    return PasswordSetAttestationFromJSONTyped(json, false);
}

export function PasswordSetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : PasswordSetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordSetAttestationToJSON(json: any): PasswordSetAttestation {
    return PasswordSetAttestationToJSONTyped(json, false);
}

export function PasswordSetAttestationToJSONTyped(value?: PasswordSetAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': PasswordSetAttestationDataToJSON(value['data']),
    };
}

